import script from "./FreeStudy.vue?vue&type=script&setup=true&lang=js"
export * from "./FreeStudy.vue?vue&type=script&setup=true&lang=js"

import "./FreeStudy.vue?vue&type=style&index=0&id=319dd54b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319dd54b"]])

export default __exports__